import ScriptsList from './ScriptsList'

export default ScriptsList